import { fork, takeEvery, takeLatest } from "redux-saga/effects";

import FacebookConstants from "modules/facebook/constants";
import FacebookSagas from "modules/facebook/sagas";
import FacebookActions from "modules/facebook/actions";

function* watchSetFacebookSettings() {
  yield takeEvery(FacebookActions.setFacebookSettings, FacebookSagas.setFacebookSettings);
}

function* watchSetFacebookConversionStatus() {
  yield takeEvery(FacebookActions.setFacebookConversionStatus, FacebookSagas.setFacebookConversionStatus);
}

function* watchSetFacebookConversionSettingStatus() {
  yield takeEvery(FacebookActions.setFacebookConversionSettingStatus, FacebookSagas.setFacebookConversionSettingStatus);
}

function* watchGetFacebookSettings() {
  yield takeEvery(FacebookActions.getFacebookSettings, FacebookSagas.getFacebookSettings);
}

function* watchGetFacebookDaSettings() {
  yield takeEvery(FacebookActions.getFacebookDaSettings, FacebookSagas.getFacebookDaSettings);
}

function* watchGetFacebookApiToken() {
  yield takeEvery(FacebookActions.getFacebookApiToken, FacebookSagas.getFacebookApiToken);
}

function* watchGetFacebookBusinessList() {
  yield takeEvery(FacebookActions.getFacebookBusinessList, FacebookSagas.getFacebookBusinessList);
}

function* watchGetFacebookAdsAccountList() {
  yield takeEvery(FacebookActions.getFacebookAdsAccountList, FacebookSagas.getFacebookAdsAccountList);
}

function* watchGetFacebookPixelCodeList() {
  yield takeEvery(FacebookActions.getFacebookPixelCodeList, FacebookSagas.getFacebookPixelCodeList);
}

function* watchGetFacebookPixelAgencies() {
  yield takeEvery(FacebookActions.getFacebookPixelAgencies, FacebookSagas.getFacebookPixelAgencies);
}

function* watchGetFacebookConversionLastSent() {
  yield takeEvery(FacebookActions.getFacebookConversionLastSent, FacebookSagas.getFacebookConversionLastSent);
}

function* watchGetFacebookCRMConversionLastSent() {
  yield takeEvery(FacebookActions.getFacebookCRMConversionLastSent, FacebookSagas.getFacebookCRMConversionLastSent);
}

function* watchGetFacebookConversionSettingByPipeline() {
  yield takeEvery(
    FacebookActions.getFacebookConversionSettingByPipeline,
    FacebookSagas.getFacebookConversionSettingByPipeline,
  );
}

function* watchGetFacebookAdsAccountAgencies() {
  yield takeEvery(FacebookActions.getFacebookAdsAccountAgencies, FacebookSagas.getFacebookAdsAccountAgencies);
}

function* watchInviteFacebookAdsAccount() {
  yield takeEvery(FacebookActions.inviteFacebookAdsAccount, FacebookSagas.inviteFacebookAdsAccount);
}

function* watchInviteFacebookPixels() {
  yield takeEvery(FacebookActions.inviteFacebookPixels, FacebookSagas.inviteFacebookPixels);
}

function* watchSyncFacebookSettingWithRdynamic() {
  yield takeEvery(FacebookActions.syncFacebookSettingWithRdynamic, FacebookSagas.syncFacebookSettingWithRdynamic);
}

function* watchSyncFacebookSettingWithRmp() {
  yield takeEvery(FacebookActions.syncFacebookSettingWithRmp, FacebookSagas.syncFacebookSettingWithRmp);
}

function* watchChangeSettingPage() {
  yield takeLatest(FacebookConstants.CHANGE_FACEBOOK_SETTING_PAGE, FacebookSagas.changeSettingPage);
}

function* watchGetRwidgetConversionDefaultValue() {
  //yield takeEvery(FacebookConstants.GET_RWIDGET_CONVERSION_DEFAULT_VALUE, FacebookSagas.getRwidgetConversionDefaultValue)
  yield takeEvery(FacebookActions.getRwidgetConversionDefaultValue, FacebookSagas.getRwidgetConversionDefaultValue);
}

function* watchRwidgetConversionDefaultValue() {
  yield takeEvery(FacebookConstants.RWIDGET_CONVERSION_DEFAULT_VALUE, FacebookSagas.rwidgetConversionDefaultValue);
}

function* watchGetFacebookPageId() {
  yield takeEvery(FacebookActions.getFacebookPageId, FacebookSagas.getFacebookPageId);
}

function* watchGetFacebookFormList() {
  yield takeEvery(FacebookActions.getFacebookFormList, FacebookSagas.getFacebookFormList);
}

function* watchGetFacebookLeadFormSettings() {
  yield takeEvery(FacebookActions.getAllLeadFormSettings, FacebookSagas.getAllLeadFormSettings);
}

function* watchSetFacebookAccount() {
  yield takeEvery(FacebookActions.setFacebookAccount, FacebookSagas.setFacebookAccount);
}

function* watchGetFacebookAccount() {
  yield takeEvery(FacebookActions.getFacebookAccount, FacebookSagas.getFacebookAccount);
}

function* watchSwitchLeadFormStatus() {
  yield takeEvery(FacebookActions.switchLeadFormStatus, FacebookSagas.switchLeadFormStatus);
}

function* watchGetLeadFormSetting() {
  yield takeEvery(FacebookActions.getLeadFormSetting, FacebookSagas.getLeadFormSetting);
}

function* watchGetFacebookPageSetting() {
  yield takeEvery(FacebookActions.getFacebookPageSetting, FacebookSagas.getFacebookPageSetting);
}

function* watchGetGoogleSetting() {
  yield takeEvery(FacebookActions.getGoogleSetting, FacebookSagas.getGoogleSetting);
}

function* watchGetCRMSetting() {
  yield takeEvery(FacebookActions.getCRMSetting, FacebookSagas.getCRMSetting);
}

function* watchSetLeadFormSetting() {
  yield takeEvery(FacebookActions.setLeadFormSetting, FacebookSagas.setLeadFormSetting);
}

function* watchGetPageSetting() {
  yield takeEvery(FacebookActions.getPageSetting, FacebookSagas.getPageSetting);
}

function* watchGetFacebookUserInfo() {
  yield takeEvery(FacebookActions.getFacebookUserInfo, FacebookSagas.getFacebookUserInfo);
}

function* watchGetFacebookNewAccessToken() {
  yield takeEvery(FacebookActions.getFacebookNewAccessToken, FacebookSagas.getFacebookNewAccessToken);
}

function* watchGetFacebookPageAccessToken() {
  yield takeEvery(FacebookActions.getFacebookPageAccessToken, FacebookSagas.getFacebookPageAccessToken);
}

function* watchGetFacebookPageByUserId() {
  yield takeEvery(FacebookActions.getFacebookPageByUserId, FacebookSagas.getFacebookPageByUserId);
}

function* watchChangePageUrlInput() {
  yield takeLatest(FacebookConstants.CHANGE_PAGE_URL_INPUT, FacebookSagas.changePageUrlInput);
}

function* watchChangePageFormSelectType() {
  yield takeLatest(FacebookConstants.CHANGE_PAGE_FORM_SELECT_TYPE, FacebookSagas.changePageFormSelectType);
}

function* watchSetCheckedFormItems() {
  yield takeLatest(FacebookConstants.SET_CHECKED_FORM_ITEMS, FacebookSagas.setCheckedFormItems);
}

function* watchDeleteLeadFormSetting() {
  yield takeEvery(FacebookActions.archiveLeadFormSetting, FacebookSagas.archiveLeadFormSetting);
}

function* watchSetFbConnected() {
  yield takeLatest(FacebookConstants.SET_FB_CONNECTED, FacebookSagas.setFbConnected);
}

function* watchSetFbDisconnected() {
  yield takeLatest(FacebookConstants.SET_FB_DISCONNECTED, FacebookSagas.setFbDisconnected);
}

function* watchSetGoogleConnected() {
  yield takeLatest(FacebookConstants.SET_GOOGLE_CONNECTED, FacebookSagas.setGoogleConnected);
}

function* watchSetGoogleDisconnected() {
  yield takeLatest(FacebookConstants.SET_GOOGLE_DISCONNECTED, FacebookSagas.setGoogleDisconnected);
}

function* watchChangeSheetsUrlInput() {
  yield takeLatest(FacebookConstants.CHANGE_SHEETS_URL_INPUT, FacebookSagas.changeSheetsUrlInput);
}

function* watchGetFacebookPageList() {
  yield takeEvery(FacebookActions.getFacebookPageList, FacebookSagas.getFacebookPageList);
}

function* watchGetUserAccessToken() {
  yield takeEvery(FacebookActions.getUserAccessToken, FacebookSagas.getUserAccessToken);
}

function* watchGetFacebookPageListMore() {
  yield takeEvery(FacebookActions.getFacebookPageListMore, FacebookSagas.getFacebookPageListMore);
}

function* watchSetValidateFacebookLeadForm() {
  yield takeLatest(FacebookConstants.SET_VALIDATE_FACEBOOK_LEAD_FORM, FacebookSagas.setValidateFacebookLeadForm);
}

function* watchSetDuplicateFacebookForm() {
  yield takeLatest(FacebookConstants.SET_DUPLICATE_FACEBOOK_FORM, FacebookSagas.setDuplicateFacebookForm);
}

function* watchGetGoogleSheetsCRMConversionsLastSend() {
  yield takeEvery(
    FacebookActions.getGoogleSheetsCRMConversionsLastSend,
    FacebookSagas.getGoogleSheetsCRMConversionsLastSend,
  );
}

function* watchGetDetailsPixelId() {
  yield takeEvery(FacebookActions.getDetailsPixelId, FacebookSagas.getDetailsPixelId);
}

function* watchUpdateSheetsModifiedData() {
  yield takeLatest(FacebookConstants.UPDATE_SHEETS_MODIFIED_DATA, FacebookSagas.updateSheetsModifiedData);
}

function* watchUpdateFBLeadFormSettingErrorStatus() {
  yield takeEvery(FacebookActions.updateFBLeadFormSettingErrorStatus, FacebookSagas.updateFBLeadFormSettingErrorStatus);
}

function* watchSetFileInfoError() {
  yield takeLatest(FacebookConstants.SET_FILE_INFO_ERROR, FacebookSagas.setFileInfoError);
}

function* watchSetFacebookLoading() {
  yield takeLatest(FacebookConstants.SET_FACEBOOK_LOADING, FacebookSagas.setFacebookLoading);
}

function* watchSetFacebookFormLoading() {
  yield takeLatest(FacebookConstants.SET_FACEBOOK_FORM_LOADING, FacebookSagas.setFacebookFormLoading);
}

function* watchSetFacebookError() {
  yield takeLatest(FacebookConstants.SET_FACEBOOK_ERROR, FacebookSagas.setFacebookError);
}

function* watchSetFBConnectionLoading() {
  yield takeLatest(FacebookConstants.SET_FB_CONNECTION_LOADING, FacebookSagas.setFBConnectionLoading);
}

function* watchSetCRMConversionsLoading() {
  yield takeLatest(FacebookConstants.SET_CRM_CONVERSIONS_LOADING, FacebookSagas.setCRMConversionsLoading);
}

export default [
  fork(watchSetFacebookSettings),
  fork(watchSetFacebookConversionStatus),
  fork(watchSetFacebookConversionSettingStatus),
  fork(watchGetFacebookSettings),
  fork(watchGetFacebookDaSettings),
  fork(watchGetFacebookApiToken),
  fork(watchGetFacebookBusinessList),
  fork(watchGetFacebookAdsAccountList),
  fork(watchGetFacebookPixelCodeList),
  fork(watchGetFacebookPixelAgencies),
  fork(watchGetFacebookConversionLastSent),
  fork(watchGetFacebookCRMConversionLastSent),
  fork(watchGetFacebookConversionSettingByPipeline),
  fork(watchGetFacebookAdsAccountAgencies),
  fork(watchInviteFacebookAdsAccount),
  fork(watchChangeSettingPage),
  fork(watchSyncFacebookSettingWithRdynamic),
  fork(watchSyncFacebookSettingWithRmp),
  fork(watchInviteFacebookPixels),
  fork(watchRwidgetConversionDefaultValue),
  fork(watchGetRwidgetConversionDefaultValue),
  fork(watchGetFacebookPageId),
  fork(watchGetFacebookFormList),
  fork(watchGetFacebookLeadFormSettings),
  fork(watchSetFacebookAccount),
  fork(watchGetFacebookAccount),
  fork(watchSwitchLeadFormStatus),
  fork(watchGetLeadFormSetting),
  fork(watchGetFacebookPageSetting),
  fork(watchGetGoogleSetting),
  fork(watchGetCRMSetting),
  fork(watchSetLeadFormSetting),
  fork(watchGetPageSetting),
  fork(watchGetFacebookUserInfo),
  fork(watchGetFacebookNewAccessToken),
  fork(watchGetFacebookPageAccessToken),
  fork(watchGetFacebookPageByUserId),
  fork(watchChangePageUrlInput),
  fork(watchChangePageFormSelectType),
  fork(watchSetCheckedFormItems),
  fork(watchDeleteLeadFormSetting),
  fork(watchSetFbConnected),
  fork(watchSetFbDisconnected),
  fork(watchSetGoogleConnected),
  fork(watchSetGoogleDisconnected),
  fork(watchChangeSheetsUrlInput),
  fork(watchGetFacebookPageList),
  fork(watchGetUserAccessToken),
  fork(watchGetFacebookPageListMore),
  fork(watchSetValidateFacebookLeadForm),
  fork(watchSetDuplicateFacebookForm),
  fork(watchGetGoogleSheetsCRMConversionsLastSend),
  fork(watchGetDetailsPixelId),
  fork(watchUpdateSheetsModifiedData),
  fork(watchUpdateFBLeadFormSettingErrorStatus),
  fork(watchSetFileInfoError),
  fork(watchSetFacebookLoading),
  fork(watchSetFacebookFormLoading),
  fork(watchSetFacebookError),
  fork(watchSetFBConnectionLoading),
  fork(watchSetCRMConversionsLoading),
];
